export const gender = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];

export const state = [
  {
    label: "FCT",
    value: "FCT",
  },
  {
    label: "Abia",
    value: "Abia",
  },
  {
    label: "Adamawa",
    value: "Adamawa",
  },
  {
    label: "Akwa Ibom",
    value: "Akwa Ibom",
  },
  {
    label: "Anambra",
    value: "Anambra",
  },
  {
    label: "Bauchi",
    value: "Bauchi",
  },
  {
    label: "Bayelsa",
    value: "Bayelsa",
  },
  {
    label: "Benue",
    value: "Benue",
  },
  {
    label: "Borno",
    value: "Borno",
  },
  {
    label: "Cross River",
    value: "Cross River",
  },
  {
    label: "Delta",
    value: "Delta",
  },
  {
    label: "Ebonyi",
    value: "Ebonyi",
  },
  {
    label: "Edo",
    value: "Edo",
  },
  {
    label: "Ekiti",
    value: "Ekiti",
  },
  {
    label: "Enugu",
    value: "Enugu",
  },
  {
    label: "Gombe",
    value: "Gombe",
  },
  {
    label: "Imo",
    value: "Imo",
  },
  {
    label: "Jigawa",
    value: "Jigawa",
  },
  {
    label: "Kaduna",
    value: "Kaduna",
  },
  {
    label: "Kano",
    value: "Kano",
  },
  {
    label: "Katsina",
    value: "Katsina",
  },
  {
    label: "Kebbi",
    value: "Kebbi",
  },
  {
    label: "Kogi",
    value: "Kogi",
  },
  {
    label: "Kwara",
    value: "Kwara",
  },
  {
    label: "Lagos",
    value: "Lagos",
  },
  {
    label: "Nasarawa",
    value: "Nasarawa",
  },
  {
    label: "Niger",
    value: "Niger",
  },
  {
    label: "Ogun",
    value: "Ogun",
  },
  {
    label: "Ondo",
    value: "Ondo",
  },
  {
    label: "Osun",
    value: "Osun",
  },
  {
    label: "Oyo",
    value: "Oyo",
  },
  {
    label: "Plateau",
    value: "Plateau",
  },
  {
    label: "Rivers",
    value: "Rivers",
  },
  {
    label: "Sokoto",
    value: "Sokoto",
  },
  {
    label: "Taraba",
    value: "Taraba",
  },
  {
    label: "Yobe",
    value: "Yobe",
  },
  {
    label: "Zamfara",
    value: "Zamfara",
  },
];

export const qualification = [
  {
    label: "PhD",
    value: "PhD",
  },
  {
    label: "Masters",
    value: "Masters",
  },
  {
    label: "Bachelors",
    value: "Bachelors",
  },
  {
    label: "HND",
    value: "HND",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const grade = [
  {
    label: "First Class",
    value: "first class",
  },
  {
    label: "Second Class Upper",
    value: "second class upper",
  },
  {
    label: "Second Class Lower",
    value: "second class lower",
  },
  {
    label: "Third Class",
    value: "third class",
  },
];

export const nysc = [
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Exempted",
    value: "exempted",
  },
  {
    label: "Awaiting Service",
    value: "awaiting",
  },
  {
    label: "Currently Serving",
    value: "serving",
  },
];

export const experience = [
  {
    label: "None",
    value: "none",
  },
  {
    label: "Beginner",
    value: "beginner",
  },
  {
    label: "Intermediate",
    value: "intermediate",
  },
];
export const info = [
  {
    label: "Facebook",
    value: "Facebook",
  },
  {
    label: "Instagram",
    value: "Instagram",
  },
  {
    label: "Twitter",
    value: "Twitter",
  },
  {
    label: "LinkedIn",
    value: "LinkedIn",
  },
  {
    label: "Whatsapp",
    value: "Whatsapp",
  },
  {
    label: "Decadev",
    value: "Decadev",
  },
  {
    label: "Other",
    value: "Other",
  },
];
export const paymentOption = [
  {
    label: "Self Sponsorship",
    value: "Self-Sponsorship",
  },
  {
    label: "Learn then earn(Student loan)",
    value: "Learn-then-earn",
  },
  {
    label: "Not Sure, I will need more info.",
    value: "Not Sure",
  },
];
export const guarantor = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const resumptionDate = [
  {
    label: "12th April 2023",
    // value: "15/03/2023",
    value: "2023-04-12",
  },
  {
    label: "15th May 2023",
    // value: "15/05/2023",
    value: "2023-05-15",
  },
  {
    label: "17th August 2023",
    // value: "15/07/2023",
    value: "2023-08-17",
  },
  // {
  //   label: "3rd July 2023, Edo",
  //   value: "07-03-2023",
  // },
];
